// src/components/ContactButton/ContactButton.js
import React from 'react';
import './ContactButton.css';

const ContactButton = ({ onClick }) => {
  return (
    <button className="contact-fab" onClick={onClick} title="Contact & Suggest Event">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path d="M22 4H2.01L2 20h20V4zm-2 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
      </svg>
    </button>
  );
};

export default ContactButton;